export default __webpack_public_path__ + "static/media/RPG_5.f65e2445.png";